import { AppCounters, Application, ItemCounters, MenuItem } from 'src/routes/root'

const mergeItems = (items: MenuItem[], counters: ItemCounters[] | null): MenuItem[] =>
    items.map((item) => {
        const itemCounters = counters?.find((counter) => counter.key === item.key)
        if (!itemCounters) return item

        return {
            ...item,
            count: itemCounters.count,
            warningCount: itemCounters.warningCount ?? 0,
            warningDescription: itemCounters.warningDescription ?? undefined,
            items: item.items ? mergeItems(item.items, itemCounters.items) : item.items,
        }
    })

const mergeAppCounters = (apps: Application[], counters: AppCounters): Application[] =>
    apps.map((app) => {
        if (app.key !== counters.key) return app

        return {
            ...app,
            modules: app.modules.map((module) => {
                const moduleCounters = counters.modules.find((counter) => counter.key === module.key)
                if (!moduleCounters) return module

                return {
                    ...module,
                    itemGroups: module.itemGroups.map((group) => {
                        const groupCounters = moduleCounters.itemGroups.find((counter) => counter.key === group.key)
                        return groupCounters ? { ...group, items: mergeItems(group.items, groupCounters.items) } : group
                    }),
                }
            }),
        }
    })

export default mergeAppCounters
